import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/eujZNG2oAS8ez1UMWzMRFg/51.png',
  title: 'Guía Rápida: 100 Frases de Supervivencia',
  description: 'Viaje + Trabajo + Vida diaria'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/9eduK5HTBXzhhRuQxokuco/52.png',
  title: 'Planner 30 Días Anti-Abandono',
  description: '15 min/día para mantener la constancia'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/nFPyR4a44yN4dPMgNK4hn4/53.png',
  title: 'Mini Tests: 5 Evaluaciones Express',
  description: 'Con respuestas + hoja de puntaje'
}];
export function BonusSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <div className="text-center mb-6" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-[#22C55E] text-white px-4 py-2 rounded-full mb-4" data-id="element-20">
            <GiftIcon className="w-5 h-5" data-id="element-21" />
            <span className="font-bold" data-id="element-22">¡GRATIS POR HOY!</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E]" data-id="element-23">
            3 BONOS EXCLUSIVOS
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-24">
          {bonuses.map((bonus, index) => <button key={index} onClick={scrollToOffer} className="bg-[#F8F9FA] rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 text-left" data-id="element-25">
              <div className="relative" data-id="element-26">
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full aspect-square object-contain" data-id="element-27" />
                <span className="absolute top-3 right-3 bg-[#22C55E] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-28">
                  GRATIS HOY
                </span>
              </div>
              <div className="p-4" data-id="element-29">
                <h3 className="font-bold text-[#1A1A2E] mb-1" data-id="element-30">
                  BONO #{index + 1}
                </h3>
                <p className="text-sm font-semibold text-[#1A1A2E] mb-1" data-id="element-31">
                  {bonus.title}
                </p>
                <p className="text-sm text-[#4A4A5A]" data-id="element-32">{bonus.description}</p>
              </div>
            </button>)}
        </div>
      </div>
    </section>;
}